/**
 * @desc 站点课程大图模块
 */
const webSiteCourseBannerList = r => require.ensure([], () => r(require('../views/webSiteCourseBanner/WebSiteCourseBannerList.vue')), 'webSiteCourseBannerList');

export default [
  //站点课程大图列表
  {
    name: 'webSiteCourseBannerList',
    path: '/webSiteCourseBannerList',
    component: webSiteCourseBannerList,
    meta: { title: '课程大图' },
  },
]